import { ThemeOptions } from '@mui/material';

import { tokens } from '../../../theme/generated/tokens';
import { cssVars } from '../../../utils/cssVars';

const { getters, setValues } = cssVars({
  color: undefined,
  textColor: undefined,
  spacing: undefined,
  size: undefined,
  fontSize: undefined,
});
export const indicatorTheme: ThemeOptions['components'] = {
  DsIndicator: {
    defaultProps: {
      color: 'blue',
      size: 'small',
      count: 0,
    },
    styleOverrides: {
      small: setValues({
        size: '16px',
        fontSize: '10px',
        spacing: '6px',
      }),
      medium: setValues({
        size: '20px',
        fontSize: '12px',
        spacing: '8px',
      }),
      large: setValues({
        size: '24px',
        fontSize: '12px',
        spacing: '8px',
      }),
      dot: setValues({
        size: '8px',
        fontSize: '0px',
      }),
      blue: () =>
        setValues({
          color: tokens.theme.bg.selection.primary,
          textColor: tokens.theme.fg.selection.onPrimary,
        }),
      ocean: () =>
        setValues({
          color: tokens.theme.bg.categorical.aquaStrong,
          textColor: tokens.theme.fg.categorical.onAquaStrong,
        }),
      indigo: () =>
        setValues({
          color: tokens.theme.bg.categorical.indigoStrong,
          textColor: tokens.theme.fg.categorical.onIndigoStrong,
        }),
      grey: () =>
        setValues({
          color: tokens.theme.bg.categorical.greyStrong,
          textColor: tokens.theme.fg.categorical.onGreyStrong,
        }),
      red: () =>
        setValues({
          color: tokens.theme.bg.status.errorStrong,
          textColor: tokens.theme.fg.status.onErrorStrong,
        }),

      root: () => ({
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '40px',
        minWidth: getters.size(),
        height: getters.size(),
        backgroundColor: getters.color(),
        color: getters.textColor(),
        padding: `0 ${getters.spacing()}`,
      }),
      label: ({ theme }) => ({
        ...theme.typography.P14M,
        fontSize: getters.fontSize(),
      }),
    },
  },
};
